package org.zq.flvtomp4.converter

sealed interface ConvertEvent {

    data class Started(
        val taskId: String,
        val durationMs: Long,
    ) : ConvertEvent

    data class Progress(
        val taskId: String,
        val progress: Float,
        val processedMs: Long,
        val speed: String?,
    ) : ConvertEvent

    data class Log(
        val taskId: String,
        val message: String,
    ) : ConvertEvent

    data class Completed(
        val taskId: String,
        val outputPath: String,
    ) : ConvertEvent

    data class Failed(
        val taskId: String,
        val message: String,
    ) : ConvertEvent

    data class Cancelled(
        val taskId: String,
    ) : ConvertEvent
}
